import * as React from 'react'

import Grid from '@material-ui/core/Grid'

import Typography           from '@material-ui/core/Typography'
import { FieldArray }       from 'formik'
import { FormattedMessage } from 'react-intl'

import { FormikFormChunkProps }   from '../../../types'
import { ActionButton }           from '../../atoms'
import {
  EducationalAchievementCard,
  InteractiveCard,
}                                 from '../../molecules'
import EducationalAchievementForm from '../EducationalAchievementForm'
import { EducationFields }        from '../types'

const EducationChunk: React.SFC<FormikFormChunkProps<EducationFields>> = ({
  errors,
  values:
    {
      education,
    },
}) => {
  const phrasing = {
    fillInEducationalPrompt:
      (
        <Typography variant={'subheading'}>
          <FormattedMessage
            id={'forms.fillInEducationalPrompt'}
            defaultMessage={'Add your educational information'}
          />
        </Typography>
      ),
    educationalAchievements:
      (
        <Typography variant={'subheading'}>
          <FormattedMessage
            defaultMessage={'Educational Achievements'}
            id={'forms.education'}
          />
        </Typography>
      ),
  }

  return (
    <Grid container spacing={24}>
      <Grid item xs={12}>
        {phrasing.fillInEducationalPrompt}
      </Grid>
      <FieldArray
        name={'education'}
        render={({ push, remove }) => {
          const achievementCards = education.map((educationalAchievement, i) => (
            <Grid item xs={12} key={i}>
              <InteractiveCard onRemove={() => remove(i)}>
                <EducationalAchievementCard {...educationalAchievement} />
              </InteractiveCard>
            </Grid>
          ))

          return (
            <>
              <Grid justify={'space-between'} alignItems={'center'} container xs={12} item>
                {phrasing.educationalAchievements}
                <EducationalAchievementForm collect={push}>
                  {({ open }) => (
                    <ActionButton
                      onClick={open}
                      actionType={'add'}
                      color={'primary'}
                    />
                  )}
                </EducationalAchievementForm>
              </Grid>
              {achievementCards}
            </>
          )
        }}
      />
      {errors.education && (
        <Grid item xs={12}>
          <Typography variant={'subheading'} color={'error'}>
            <FormattedMessage id={'validation.' + (String(errors.education) || 'formik-update-error')} />
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default EducationChunk



// WEBPACK FOOTER //
// ./src/components/forms/chunks/EducationChunk.tsx